// Value of the Work Orders page's `?view=` search param.
export enum WorkOrderPageView {
  BOARD = 'board',
  SETTINGS = 'settings',
}

export enum WorkOrderModalMode {
  VIEW = 'view',
  EDIT = 'edit',
  CREATE = 'create',
}

export enum WorkOrderPanel {
  CALENDAR = 'calendar',
  MAP = 'map',
}

export enum WorkOrderCalendarMode {
  MONTH = 'month',
  WEEK = 'week',
}
